import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=48601552&scoped=true"
import script from "./sign-in.vue?vue&type=script&lang=js"
export * from "./sign-in.vue?vue&type=script&lang=js"
import style0 from "./sign-in.vue?vue&type=style&index=0&id=48601552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48601552",
  null
  
)

export default component.exports